import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '../common/Alert.js';
import contractPartyService from '../../services/contractPartyService.js';
import { UserPlus } from 'lucide-react';
import { validators, inputFilters, useValidation } from '../common/Validation.js';
import ContractPartyForm from './ContractPartyForm.js';
import { useTranslation } from 'react-i18next';


const AddContractParty = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    email: '',
    gst_number: '',
    company_name: '',
    address: '',
    status: 'active'
  });
  const { errors, validate, validateField } = useValidation();

  const validationRules = {
    name:         (v) => validators.required(v, 'Name') || validators.textOnly(v, 'Name'),
    contact:      (v) => validators.required(v, 'Contact') || validators.contact(v),
    email:        (v) => validators.required(v, 'Email') || validators.email(v),
    company_name: (v) => validators.required(v, 'Company name'),
    gst_number:   (v) => v ? validators.gst(v) : '',
    address:      (v) => validators.required(v, 'Address'),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let filtered = value;
    if (name === 'contact') filtered = inputFilters.digits10(value);
    else if (name === 'name') filtered = inputFilters.lettersOnly(value);
    else if (name === 'gst_number') filtered = value.toUpperCase();

    setFormData(prev => ({ ...prev, [name]: filtered }));

    if (validationRules[name]) {
      validateField(name, filtered, validationRules[name]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate(formData, validationRules)) {
      Alert.error('Please fix the highlighted errors before submitting');
      return;
    }

    try {
      setLoading(true);
      await contractPartyService.create(formData);
      Alert.success('Contract party created successfully!');
      navigate('/contract-parties');
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Failed to create contract party');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContractPartyForm
      title={t('pages.contractParty.add')}
      icon={UserPlus}
      formData={formData}
      errors={errors}
      onChange={handleChange}
      onSubmit={handleSubmit}
      onCancel={() => navigate('/contract-parties')}
      loading={loading}
      submitLabel="Create Contract Party"
      loadingLabel="Creating..."
    />
  );
};

export default AddContractParty;
